import { RegistrationDataProvider } from "../../providers/RegistrationDataProvider/Provider";
import Registration from "./Registration";

export const RegistrationWithProvider = (props) => (
  <RegistrationDataProvider dataUrl={props.dataUrl}>
    <Registration {...props} />
  </RegistrationDataProvider>
);